import authApi from './auth-api'
import smsApi from './sms-api'
import ultronApi from './ultron-api'
import gpActivities from './gp-activities'
import gpOrder from './gporder-api'
import gpUser from './gpuser-api'
import gpDatacenter from './gp-datacenter'
import gpLive from './gp-live'
import gpAuthor from './gp-author'
import gpCaishang from './gp-caishang'
import jindashiApi from './jindashi-api'

// api链接静态资源
export default {
  ...authApi,
  ...smsApi,
  ...ultronApi,
  ...gpActivities,
  ...gpOrder,
  ...gpUser,
  ...gpDatacenter,
  ...gpLive,
  ...gpAuthor,
  ...gpCaishang,
  ...jindashiApi
}
